import { Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AbstractIndexSection } from '../../abstract-index-section';
import { SECTION_DATA } from '../../service/section-data';
import { Section } from 'src/app/web-generator/template-generator/entity/section';
import { GENERATOR_ENV_TOKEN, GeneratorEnv } from 'src/app/web-generator/generator-env-token';
import { BannerMeta } from '../../../template-generator/entity/banner-meta';
import { TemplateService } from '../../../template-generator/service/template.service';
import { map } from 'rxjs/operators';
import { ServerConfigService } from 'src/app/share/service/server-config.service';

export abstract class AbstractIndexBanner extends AbstractIndexSection<BannerMeta[]> implements OnInit {
  belongSiteModules = [];

  constructor(
    @Inject(SECTION_DATA) protected section: Section,
    @Inject(GENERATOR_ENV_TOKEN) protected generatorEnv: GeneratorEnv,
    @Inject(PLATFORM_ID) protected platformId: object,
    protected serverConfigService: ServerConfigService,
    protected translate: TranslateService,
    protected templateService: TemplateService,
  ) {
    super(section, generatorEnv, platformId, serverConfigService, templateService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  refreshRemoteData() {
    this.templateService.siteInfo$.pipe(
      map(siteInfo => {
        return siteInfo.banners;
      })
    ).subscribe(
      (bannerMeta: BannerMeta[]) => {
        this.remoteData = bannerMeta;
      },
      (error) => this.remoteData = this.remoteDefaultData
    );
  }
}
